import React from 'react';

import PropTypes from 'prop-types';

import { Card } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import DashboardErrorCard from '../../DashboardErrorCard/DashboardErrorCard';

function DashboardMainCard({
  extraInfo,
  type,
  accessibilityLabel,
  componentName,
  showAction,
  style,
  onPressCard,
  hasShadow,
  loadingConfig,
  shimmerPlaceholderConfig,
  isLoading,
  cardAccessible,
  error,
  errorCardProps,
  children,
  isFourthCard,
  ...props
}) {
  const { accessibilityID, errorText, errorHandler, isVerticalLayout, isHorizontalLayout } =
    errorCardProps;
  return (
    <Card
      {...props}
      extraInfo={extraInfo}
      type={type}
      accessibilityLabel={accessibilityLabel}
      componentName={componentName}
      showAction={showAction}
      style={style}
      onPressCard={onPressCard}
      hasShadow={hasShadow}
      loadingConfig={loadingConfig}
      shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      isLoading={isLoading}
      cardAccessible={cardAccessible}
      testID={FrameworkTestKeys.dashboardMainCard}
      isFourthCard={isFourthCard}
    >
      {!error ? (
        children
      ) : (
        <DashboardErrorCard
          accessibilityID={accessibilityID}
          errorText={errorText}
          errorHandler={errorHandler}
          isVerticalLayout={isVerticalLayout}
          isHorizontalLayout={isHorizontalLayout}
        />
      )}
    </Card>
  );
}

DashboardMainCard.propTypes = {
  extraInfo: PropTypes.any,
  type: PropTypes.oneOf(['main', 'sec', 'addMore']),
  accessibilityLabel: PropTypes.string,
  componentName: PropTypes.string,
  showAction: PropTypes.bool,
  style: PropTypes.object,
  onPressCard: PropTypes.func,
  hasShadow: PropTypes.bool,
  loadingConfig: PropTypes.array,
  shimmerPlaceholderConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  cardAccessible: PropTypes.bool,
  error: PropTypes.bool,
  errorCardProps: PropTypes.object,
  children: PropTypes.element,
};

DashboardMainCard.defaultProps = {
  errorCardProps: {},
};

export default DashboardMainCard;
